import React, { Ref } from "react";
import { TableToggleAllRowsSelectedProps } from "react-table";

interface CheckboxProps extends TableToggleAllRowsSelectedProps {
    isHeader?: boolean
    data?: any
}

//   { indeterminate, data,isHeader=false, ...rest }

export const Checkbox = React.forwardRef(
    ({ indeterminate, ...rest }: CheckboxProps,ref:any) => {

        const { data, isHeader } = rest;
        const defaultRef = React.useRef<HTMLInputElement>(null);
        const resolvedRef = ref || defaultRef 

        React.useEffect(() => {
            if (resolvedRef && resolvedRef.current) {
                resolvedRef.current.indeterminate = indeterminate;
            }

        }, [resolvedRef, indeterminate])

        if ((data && data.cert && data.cert.estadocertificado === "G") || isHeader) {
            return (
                <>
                    <input type="checkbox" ref={resolvedRef} {...rest} />
                </>
            )
        }
        else {
            return (
                <div ref={resolvedRef} > </div>
            )
        }
    })